var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.502,
    height: 17.478,
    viewBox: "0 0 17.502 17.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-user",
    "data-name": "Icon feather-user",
    transform: "translate(-5.626 -3.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M21.8,28.426V26.451A3.951,3.951,0,0,0,17.852,22.5h-7.9A3.951,3.951,0,0,0,6,26.451v1.975",
    transform: "translate(0.476 -8.148)",
    fill: "none",
    stroke: "#42687b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M19.9,8.451A3.951,3.951,0,1,1,15.951,4.5,3.951,3.951,0,0,1,19.9,8.451Z",
    transform: "translate(-2.049)",
    fill: "none",
    stroke: "#e85257",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersBlue);
export default __webpack_public_path__ + "static/media/UsersBlue.1be06054746d4de5d0459959fd34eb28.svg";
export { ForwardRef as ReactComponent };